export interface BonusItem {
  id: number;
  amount: number;
  type: BonusItemType;
  createdAt?: Date;
  updatedAt?: Date;
  payslipId: number;
}

export enum BonusItemType {
  COMMISION = "COMMISION",
  ANNUAL_LEAVE_ENCASHMENT = "ANNUAL_LEAVE_ENCASHMENT",
  BONUS = "BONUS",
  AWS = "AWS",
  DIRECTOR_FEE = "DIRECTOR_FEE",
  BACK_PAY = "BACK_PAY",
}
export const BonusItemTypeLabels: { [key in BonusItemType]: string } = {
  [BonusItemType.COMMISION]: "Commision",
  [BonusItemType.ANNUAL_LEAVE_ENCASHMENT]: "Annual Leave Encashment",
  [BonusItemType.BONUS]: "Bonus",
  [BonusItemType.AWS]: "AWS",
  [BonusItemType.DIRECTOR_FEE]: "Director Fee",
  [BonusItemType.BACK_PAY]: "Back Pay",
};
